import { makeStyles, Theme, createStyles } from "@material-ui/core";

import colors from "../../../../common/styles/colors";
import palette from "../../../../common/styles/palette";

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    boxConclude: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 24px",
      border: "1px solid " + colors.redMedium,
      borderRadius: palette.radius,
      backgroundColor: colors.redLight,
    },
    boxConcludeProgress: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
    },
    boxConcludeButton: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
    },
    description: {
      width: "100%",
      textAlign: "left",
      paddingTop: "10px",
      justifyContent: "flex-start",
      marginTop: theme.spacing(2),
    },
    concludedBox: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 24px",
      border: "1px solid " + colors.greenDark,
      borderRadius: palette.radius,
      backgroundColor: colors.greenLight,
    },
  })
);
